<ion-app>
  <router-outlet></router-outlet>
</ion-app>

<von-toast class="toast__wrapper" [stackVisibleLimit]="15" />
